export const CREATE_ENTITLEMENT_EXCEPTION = `
  mutation CreateException($entityId: ID!, $entitlementId: ID!, $userId: ID!, $exceptionType: String!  ) {
    createEntityException(entityId: $entityId, entitlementId: $entitlementId, userId: $userId, exceptionType: $exceptionType){
      entityException {
        id
        entityId
        exceptionType
        user {
          id
          name
        }
        entitlement {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_USERS = `
  query {
    users {
      id
      name
    }
  }
`;

export const GET_COMPANIES = `
  query {
    companies {
        id
        name
        petraId
    }
  }
`;

export const GET_CUSTOMERS = `
  query {
    customers {
      id
      petraId
      firstName
      lastName
    }
  }
`;

export const GET_EXCEPTIONS = `
query GetExceptions($entitlementId:ID!) {
  entityExceptions(entitlementId: $entitlementId) {
    id
    entityId
    exceptionType
    entitlement {
      id
      name
      relatedModel
    }
    user {
      id
      name
    }
  }
}
`;

export const GET_ENTITLEMENT = `
  query GetEntitlement($id:ID!) {
    entitlement(id: $id) {
      id
      name
      relatedModel
    }
  }
`;

export const DELETE_ENTITY_EXCEPTION = `
  mutation DeleteEntityException($id:ID!) {
    deleteEntityException(id: $id ){
      result
      errors {
        property
        description
      }
    }
  }
`;

export const MASS_GET_CUSTOMERS = `
query MassGetCustomers($ids: [ID!]!) {
  bulkCustomers(ids: $ids) {
    id
    firstName
    lastName
    ssnitNumber
    gender
    dateOfBirth
  }
}
`;

export const MASS_GET_COMPANY = `
query MassGetCompanies($ids: [ID!]!) {
  bulkCompanies(ids: $ids) {
    id
    name
    tinNumber
  }
}
`;
